<template>
  <OAuthApplicationCreate @closed="emit('closed')" />
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';

import OAuthApplicationCreate from '@/components/OAuthApplicationCreate.vue';

const emit = defineEmits<{
  closed: [];
}>();

useHead({ title: 'Create Integration - API Integrations - API - Crossbeam' });
</script>
